import React, { useEffect, useState } from "react";

import clsx from "clsx";
import { HatGlasses } from "lucide-react";

import {
  masqueradeToken,
  masqueradingMinutesLeft,
  useMasqueradeBarOpen,
} from "@/util";
import { handleStopMasquerading } from "@/MasqueradePage/MasqueradeComponent";
import { ActiveOverridesInfo } from "@/Topbar/ActiveOverridesInfo";
import {
  StatusStrip,
  StatusStripButton,
  statusStripHoverClassName,
} from "@/components/StatusStrip";

export const MasqueradeBar: React.FC = () => {
  const whoAmI = masqueradeToken();
  const [minutesLeft, setMinutesLeft] = useState(0);
  const shouldShow = useMasqueradeBarOpen();

  useEffect(() => {
    const interval = setInterval(() => {
      setMinutesLeft(masqueradingMinutesLeft() ?? 0);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  if (!shouldShow) {
    return null;
  }

  return (
    <StatusStrip
      tone="masquerade"
      label="Masquerade"
      icon={<HatGlasses size={16} aria-hidden className="shrink-0" />}
    >
      <span className="min-w-0 truncate">
        WARNING: Masquerading as {whoAmI}.{" "}
        {minutesLeft > 0 && `${minutesLeft} minutes left.`}
      </span>
      <ActiveOverridesInfo
        className={clsx(
          statusStripHoverClassName("masquerade"),
          "focus:bg-masquerade-strip-text/20 shrink-0 rounded-sm p-0.5",
        )}
      />
      <span className="flex-1" />
      <StatusStripButton
        tone="masquerade"
        onClick={() => handleStopMasquerading()}
        title="Stop masquerading"
      >
        Stop
      </StatusStripButton>
    </StatusStrip>
  );
};
